<template>
  <section id="section-3" class="content-current">
    <div class="row">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <router-link to="/profile/dashboard">
          <div title="بازگشت به داشبورد" class="close"></div>
        </router-link>
      </div>
    </div>
    <div class="content-current">
      <div class="row">
        <div class="col-md-4">
          <!-- <div class="group_mdi inputContainer">
            <div class="icon-position">
              <i class="icon_calendar icon"></i>
            </div>
            <input
              type="text"
              v-datepicker
              :value="convertDate(fromDate)"
              @change="fromDate = $event.detail.GregorianDate"
            />
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="lbl-report">از تاریخ:</label>
          </div> -->
          <label>از تاریخ:</label>
          <date-picker display-format="jYYYY/jMM/jDD" color="#00C3E1" popover="bottom-right" auto-submit locale="fa"
            v-model="fromDate" />
          <span class="highlight"></span><span class="bar"></span>
        </div>
        <div class="col-md-4">
          <!-- <div class="group_mdi inputContainer">
            <div class="icon-position">
              <i class="icon_calendar icon"></i>
            </div>
            <input
              type="text"
              v-datepicker
              :value="convertDate(toDate)"
              @change="toDate = $event.detail.GregorianDate"
            />
            <span class="highlight"></span><span class="bar"></span>
            <label class="lbl-report">تا تاریخ:</label>
          </div> -->
          <label>تا تاریخ:</label>
          <date-picker display-format="jYYYY/jMM/jDD" color="#00C3E1" popover="bottom-right" auto-submit locale="fa"
            v-model="toDate" />
          <span class="highlight"></span><span class="bar"></span>
        </div>
        <div class="col-md-4">
          <div class="group_mdi">

            <input type="text" v-model="voucherNumber" />
            <span class="highlight"></span><span class="bar"></span>
            <label class="lbl-report"> شماره واچر:</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 btn-align">
          <button type="submit" class="btn btn-primary" @click="search">
            جستجو
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="col-md-12 loading" v-if="isLoading">
      <loadingBar type="ripple" />
    </div>
    <div class="scrollable">
      <table class="table tablesorter add_bottom_30" v-if="!isLoading">
        <thead class="thead-light">
          <tr>
            <th>تاریخ ثبت</th>
            <th>شماره رزرو</th>
            <th>شماره واچر</th>
            <th>تاریخ ورود</th>
            <th>نام فروشنده</th>
            <th>نام مشتری</th>
            <th>برنامه زمانی</th>
            <th>نفرات رزرو شده</th>
            <th>نفرات ورودی</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in entryList">
            <tr @click="toggle(index + 1)" class="td-detail" :class="{ opened: opened.includes(index + 1) }">
              <td>{{ item.createdDate | persianDate("jYYYY/jMM/jDD") }}</td>
              <td>{{ item.reserveNumber }}</td>
              <td>{{ item.voucherNumber }}</td>
              <td>{{ item.arrivalDateShamsi }}</td>
              <td>{{ item.sourceName }}</td>
              <td>{{ item.customerFullName }}</td>
              <td>{{ item.scheduleName }}</td>
              <td>{{ item.pax }}</td>
              <td>{{ item.reservedChild + item.reservedAdult }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <div class="btn-align">
      <h3 v-if="!hasShowResult">نتیجه ای یافت نشد !!!!</h3>
    </div>
  </section>
</template>

<script>
import Store from "../../../../views/profile/store/index";
import moment from "moment-jalaali";
import loadingBar from "../../../../components/loading/pdkLoadingBar";
import date from "../../../../utils/date";

export default {
  name: "creditReport",
  store: Store,
  components: { loadingBar },
  data() {
    return {
      now: moment(),
      isLoading: false,
      fromDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      toDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      entryList: [],
      opened: [],
      reserveStatus: "",
      voucherNumber: "",
      hasShowResult: false,
    };
  },
  created() { },

  methods: {
    convertDate(date) {
      if (date === "0001-01-01T00:00:00") return "";
      if (!moment(date).isValid()) return "";
      const pdate = moment(date).format("jYYYY/jMM/jDD");
      return pdate;
    },
    async search() {
      const data = {
        fromDate: date.ConvertToGregorian(this.fromDate),
        toDate: date.ConvertToGregorian(this.toDate),
        sourceId: localStorage.getItem("SourceIdInReport"),
        sourceProfileId: localStorage.getItem("SourceProfileId"),
        isAdmin: false,
        reserveStatus: this.reserveStatus,
        voucherNumber: this.voucherNumber,
        providerId: 1,
      };
      this.isLoading = true;

      this.entryList = await this.$store.dispatch("getDolphinEntry", data);
      this.isLoading = false;
      this.hasShowResult = true;

      if (this.entryList.length) this.hasShowResult = true;
    },

    toggle(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.push(id);
      }
    },
  },
};
</script>

<style scoped>
.btn-profile {
  width: 180px !important;
}

.btn-align {
  /* text-align: center; */
  margin-top: 20px !important;

  /* padding-right: 70px !important;
  padding-left: 70px !important; */
}

.icon-top {
  margin-top: 38px;
  font-size: 40px;
}

.icon-bottom {
  margin-top: 38px;
  font-size: 22px;
}

.icon-position {
  float: left;
  margin-left: 26px;
}

/* .opened {
  background-color: yellow;
} */
.td-opened {
  background-color: rgb(4 112 167) !important;
  color: white;
}

.loading {
  height: 1000px !important;
  text-align: center !important;
  margin-top: 200px !important;
}

h3 {
  color: #777 !important;
}
</style>

<style scoped lang="scss">
.scrollable {
  overflow: hidden;
  position: relative;
  width: 100%;

  &.is-scrollable:after {
    position: absolute;
    top: 0;
    left: 100%;
    width: 50px;
    height: 100%;
    border-radius: 10px 0 0 10px / 50% 0 0 50%;
    box-shadow: -5px 0 10px rgba(0, 0, 0, 0.25);
    content: "";
  }

  // the overflow-er
  >div {
    overflow-x: auto;

    // forces scrollbar for webkit
    ::-webkit-scrollbar {
      height: 12px;
    }

    ::-webkit-scrollbar-track {
      background: #f0f0f0;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.15) inset;
    }

    ::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 6px;
    }
  }
}
</style>